module.exports = __webpack_public_path__ + "img/cd-bar-image.340e68d2.png";